// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"d027980a","797":"a359cdaf"}[chunkId] + ".chunk.css";
};